module.exports = __webpack_public_path__ + "static/media/cockroach(2).bb1ecb32.PNG";